import { DownloadOutlined } from "@mui/icons-material";

export function download(url: string, name?: string) {
  window.open(url, "_blank");
}

export const DowlonadButton = (props: { url: string; name?: string; children?: React.ReactNode }) => {
  return <DownloadOutlined onClick={() => download(props.url, props.name)} />;
};
